import { observer } from "mobx-react-lite";

import { DATE_FORMATS, DateTime } from "@bps/date-time";
import { Heading, Stack, Text } from "@bps/fluent-ui";
import { XeroFinancialSyncData } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { capitalizeSentence } from "@libs/utils/utils.ts";

interface XeroSyncHistoryListProps {
  data: XeroFinancialSyncData[];
}

export const XeroSyncHistoryList = observer(
  ({ data }: XeroSyncHistoryListProps) => {
    return (
      <Stack tokens={{ childrenGap: 24 }}>
        {data.map(
          ({
            id,
            operationType,
            operationDate,
            changeLog,
            payload,
            status,
            statusDetails
          }) => (
            <Stack key={id} tokens={{ childrenGap: 4 }}>
              <Heading>
                {operationType} - {capitalizeSentence(status)}
              </Heading>
              <Text>
                {payload.status
                  ? capitalizeSentence(payload.status)
                  : undefined}
              </Text>
              <Text>
                Sync:{" "}
                {DateTime.fromISO(
                  changeLog.updatedDate || changeLog.createdDate
                ).toFormat(DATE_FORMATS.LONG_DATE_FORMAT)}
              </Text>
              {payload.items?.length ? (
                <Stack>
                  {payload.items.map(item => (
                    <Text key={item.description}>
                      {item.description}{" "}
                      {DateTime.fromISO(operationDate).toFormat(
                        DATE_FORMATS.LONG_DATE_TIME_FORMAT
                      )}
                    </Text>
                  ))}
                </Stack>
              ) : undefined}
              {statusDetails.length ? (
                <Stack>
                  <Heading>Messages</Heading>
                  {statusDetails.map(({ message }) => (
                    <Text key={message}>{message}</Text>
                  ))}
                </Stack>
              ) : undefined}
            </Stack>
          )
        )}
      </Stack>
    );
  }
);
